const services = [
  {
    icon: "ri-hospital-line",
    title: "Hospital Turnkey Projects",
    description:
      "Complete end-to-end hospital project management — from initial planning, architectural design, equipment procurement, logistics, installation, and final commissioning.",
    features: ["Project Planning & Design", "Procurement Management", "Installation & Commissioning", "Quality Assurance"],
    bg: "bg-orange-50",
    iconBg: "bg-orange-100",
    iconColor: "text-orange-500",
    accent: "border-orange-200",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "ICU & Critical Care Equipment",
    description:
      "Supply of advanced ICU, Neonate, and Emergency department equipment, ensuring critical care units are equipped with the latest life-saving technology.",
    features: ["ICU Monitors & Ventilators", "Neonatal Care Systems", "Emergency Equipment", "CPAP/BPAP Devices"],
    bg: "bg-emerald-50",
    iconBg: "bg-emerald-100",
    iconColor: "text-emerald-600",
    accent: "border-emerald-200",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "Hospital Furniture",
    description:
      "High-quality hospital furniture and durable stainless steel medical equipment designed to meet stringent hygiene and operational standards in clinical environments.",
    features: ["Patient Beds & Trolleys", "Stainless Steel Equipment", "Operating Room Furniture", "Ward Furniture"],
    bg: "bg-amber-50",
    iconBg: "bg-amber-100",
    iconColor: "text-amber-600",
    accent: "border-amber-200",
  },
  {
    icon: "ri-microscope-line",
    title: "Urology & Radiology Equipment",
    description:
      "Specialized urology and radiology equipment supply, including Lithotripsy systems, mobile X-ray units, and C-Arm imaging systems for advanced diagnostics.",
    features: ["Lithotripsy Systems", "Mobile X-Ray Units", "C-Arm Imaging Systems", "Radiology Solutions"],
    bg: "bg-rose-50",
    iconBg: "bg-rose-100",
    iconColor: "text-rose-500",
    accent: "border-rose-200",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold tracking-widest uppercase text-amber-500 mb-3">Our Expertise</span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight">
            Comprehensive Medical
            <span className="block text-amber-500">Equipment Solutions</span>
          </h2>
          <p className="mt-4 text-gray-500 text-base max-w-2xl mx-auto">
            From ICU devices to complete hospital infrastructure — ANDINI delivers tailored solutions for every healthcare environment.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => (
            <div
              key={s.title}
              className={`rounded-2xl p-6 border ${s.bg} ${s.accent} hover:scale-[1.02] transition-transform duration-200 flex flex-col`}
            >
              <div className={`w-14 h-14 flex items-center justify-center ${s.iconBg} rounded-xl mb-5`}>
                <i className={`${s.icon} text-2xl ${s.iconColor}`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{s.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-5 flex-1">{s.description}</p>
              <ul className="space-y-1.5">
                {s.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-fill text-amber-500 text-base flex-shrink-0"></i>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
